export default __webpack_public_path__ + "static/speechbubbles3-72a39ca2a649b1547a0a61e39c378a8e.png";